/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-layer-popover-arrow-padding: 0px;
  --nve-sys-layer-popover-arrow-offset: 0px;
  --nve-sys-layer-popover-offset: var(--nve-ref-space-xl);
  --nve-sys-interaction-color: var(--color);
  --nve-sys-interaction-hover-color: var(--color);
  --border-radius: var(--nve-ref-border-radius-md);
  --status-color: var(--nve-sys-support-color);
  --background: var(--nve-sys-layer-popover-background);
  --color: var(--nve-sys-layer-popover-color);
  --padding: var(--nve-ref-size-500) var(--nve-ref-size-900);
  --box-shadow: var(--nve-ref-shadow-400);
  --gap: var(--nve-ref-space-md);
  --min-width: 320px;
  --width: fit-content;
  --max-width: fit-content;
  --border: 0;
  --status-border: 6px solid var(--status-color);
  width: var(--width);
}

[internal-host] {
  box-shadow: var(--box-shadow);
  padding: var(--padding);
  border-radius: var(--border-radius);
  background: var(--background);
  color: var(--color);
  gap: var(--gap);
  border: var(--border);
  border-inline-start: var(--status-border);
  min-width: var(--min-width);
  max-width: var(--max-width);
  display: flex;
  flex-direction: column;
  position: relative;
}

[internal-host]:has(nve-icon-button) {
  padding-inline-end: var(--nve-ref-size-1000);
}

nve-icon-button {
  position: absolute;
  inset-block-start: var(--nve-ref-size-150);
  inset-inline-end: var(--nve-ref-size-150);
}

nve-icon-button::part(icon) {
  --color: var(--nve-sys-layer-popover-color) !important;
}

[part='status-icon'],
::slotted([slot='icon']) {
  position: absolute;
  inset-block-start: var(--nve-ref-size-400);
  inset-inline-start: var(--nve-ref-size-300);
  --color: var(--status-color);
}

::slotted([nve-text]) {
  color: inherit !important;
}

:host([container='flat']) {
  --max-width: 100%;
  --width: 100%;
  --border-radius: 0;
  --box-shadow: none;
  --border: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
  --background: var(--nve-sys-layer-overlay-accent-background);
  --color: var(--nve-sys-layer-overlay-color);
  position: relative;
  margin: 0;
}

:host([container='flat']) nve-icon-button::part(icon) {
  --color: var(--nve-sys-layer-overlay-color) !important;
}

:host([container='flat']) .popover {
  border-block-end: var(--border);
}

:host([status='accent']) {
  --status-color: var(--nve-sys-support-accent-color);
}

:host([status='success']) {
  --status-color: var(--nve-sys-support-success-color);
}

:host([status='warning']) {
  --status-color: color-mix(in oklab, var(--nve-sys-support-warning-color) 90%, var(--nve-sys-contrast-mute-color));
}

:host([status='danger']) {
  --status-color: var(--nve-sys-support-danger-color);
}
